import Divider from "../../../../../../packages/design-system/src/Divider";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  Divider,
  Spacings,
  Text,
  React
};